import React from "react";
import {
  Box,
  Button,
  Hidden,
  IconButton,
  Inline,
} from "@origin-digital/ods-core";
import { IconPlus, IconClose, IconSearch } from "@origin-digital/ods-icons";
import { SearchFieldResponsive } from "src/components/Form/SearchField";
import { ActionSectionProps } from "./types";
import { useActionSection } from "./useActionSection";
import { useSearchAction } from "src/context/NewPremiseFormContext";

export const ActionSectionBelowMd = (props: ActionSectionProps) => {
  const { newProjectButtonProps } = useActionSection(props);
  const {
    searchFieldProps,
    closeSearchIconButtonProps,
    openSearchIconButtonProps,
    searchFieldShown,
  } = useSearchAction();
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={["medium", "large"]}
      data-id="actionSection.root"
    >
      {/* Actions inner container */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexDirection={{
          xs: "row",
          lg: "row-reverse",
        }}
      >
        {/* New project */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          gap="small"
          data-id="actionSection.newProjectButtonBox"
        >
          <Button
            size="small"
            icon={<IconPlus color="inherit" />}
            {...newProjectButtonProps}
          >
            <Inline>
              <Hidden below="lg">New project</Hidden>
              <Hidden above="lg">New</Hidden>
            </Inline>
          </Button>
        </Box>
        {/* End New project */}
        {/* Search */}
        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          flexDirection={{
            xs: "row",
            lg: "row-reverse",
          }}
          gap={{
            xs: "xxxsmall",
            md: "medium",
          }}
          data-id="actionSection.searchFieldBox"
        >
          {/* Search (XS > MD) */}
          {searchFieldShown ? (
            <IconButton {...closeSearchIconButtonProps}>
              <IconClose aria-label="Close search" size="xsmall" />
            </IconButton>
          ) : (
            <IconButton {...openSearchIconButtonProps}>
              <IconSearch aria-label="Search" size="xsmall" />
            </IconButton>
          )}
          {/* End Search (XS > MD) */}
        </Box>
        {/* End Search */}
      </Box>
      {/* End Actions inner container */}

      {/* Search field (XS > MD) */}
      {searchFieldShown && <SearchFieldResponsive {...searchFieldProps} />}
      {/* End Search field (XS > MD) */}
    </Box>
  );
};
